export function isInvitaionBelongingToUser({ invitationData, profileData }) {
  if (!profileData) {
    return true
  }
  if (!invitationData) {
    return false
  }

  return (
    invitationData?.loginUsernameId === profileData?.email ||
    invitationData?.loginUsernameId === profileData?.mobile
  )
}

export function isUserLoggedIn({ profileData }) {
  return !!profileData
}
